// Global event bus used to pass errors to Notification component
import Vue from 'vue';

export default new Vue();
